import { BaseCardsClient } from "../types/clients";
import { Card } from "@core/types";

interface BackCard {
  card_first_six: string;
  card_last_four: string;
  card_type: string;
  created_at: string;
  id: string;
  payment_method_id: string;
  updated_at: string;
  customer_id: string;
}

class CardsClient extends BaseCardsClient {
  async getCards(): Promise<Card[]> {
    const { data } = await this.instance.get<BackCard[]>("/wp-json/wc/v3/cards");

    return data.map((data) => {
      return {
        id: data.id,
        userId: data.customer_id,
        cardType: data.card_type,
        cardFirstSix: data.card_first_six,
        cardLastFour: data.card_last_four,
        paymentMethodId: data.payment_method_id,
        dataCreated: data.created_at,
        dataUpdated: data.updated_at,
      };
    });
  }

  async deleteCard({ id }: { id: string }) {
    // TODO: fix type
    const { data } = await this.instance.delete(`/wp-json/wc/v3/cards/${id}`);
    return data;
  }
}

export default CardsClient;
